import axios from "axios";

export default function UserPasswordSetService(formData) {
  return axios({
    method: 'post',
    url: process.env.REACT_APP_API_HOST + "/api/v2/password-reminder",
    data: formData,
    params: {},
    headers: {}
  });
}
